/** @jsx h */
import { h } from 'preact'
import Capsule from '../Capsule'
import ClaimVerifier from './ClaimVerifier'

const ConnectionCard = props => {
  const { collaborator, footer, claimStatus } = props

  const footerClass = footer ? 'shown' : 'hidden'

  return (
    <div
      class='ClaimCard'
    >
      <div class='ClaimCard-inner'>
        <div class='ClaimCard-title ClaimCard-title--embed'>
          <Capsule label='Connection' small />
        </div>
        <div class='Card-content--connection'>
          <div class='Card-details--connection'>
            <ClaimVerifier verifier={collaborator} claimStatus={claimStatus} showStatus showArrow />
          </div>
        </div>
      </div>
      <div class={`ClaimCard-footer ClaimCard-footer--${footerClass}`}>
        {footer}
      </div>
    </div>
  )
}

ConnectionCard.defaultProps = {
  footer: null
}

export default ConnectionCard
